import { render, staticRenderFns } from "./uvForm.vue?vue&type=template&id=5aaf4b2a&scoped=true&"
import script from "./uvForm.vue?vue&type=script&lang=js&"
export * from "./uvForm.vue?vue&type=script&lang=js&"
import style0 from "./uvForm.vue?vue&type=style&index=0&id=5aaf4b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf4b2a",
  null
  
)

export default component.exports